import { render } from "./PForm.vue?vue&type=template&id=cfb38882&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PForm.vue?vue&type=script&lang=js"
export * from "./PForm.vue?vue&type=script&lang=js"

import "./PForm.vue?vue&type=style&index=0&id=cfb38882&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfb38882"]])

export default __exports__